<template>
  <div class="view-leads">
    <div class="header mb-6">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-0"
        @click="goBack()"
      ></vs-button>
      <div class="w-1/2 justify-right">
        <h2 class="pl-2">{{ $t("labels.questionnaire_view") }}</h2>
      </div>
      <div class="history w-1/2 justify-right">
        <vs-button
          color="dark"
          type="filled"
          icon-pack="feather"
          icon="icon-activity"
          @click="
            $router.push({ name: 'History', params: { id: id, model: model } })
          "
          class="float-right"
        >{{ $t("labels.history") }}</vs-button>
      </div>
    </div>
    <div class="view-lead">
      <vx-card class="contact-details" :title="$t('labels.questionnaire_details')">
        <div class="vx-row mb-4">
          <div class="vx-col w-full mb-4">
            <div class="vx-row mb-4">
              <div class="vx-col sm: w-1/2 md:w-1/5 mb-4">
                <label>{{ $t("labels.question_name") }}:</label>
              </div>
              <div class="vx-col sm: w-1/2 mb-4">
                <span>{{ question_name }}</span>
              </div>
            </div>
            <div class="vx-row mb-4">
              <div class="vx-col sm: w-1/2 md:w-1/5 mb-4">
                <label>{{ $t("labels.section") }}:</label>
              </div>
              <div class="vx-col sm: w-1/2 mb-4">
                <span>{{ section }}</span>
              </div>
            </div>
            <div class="vx-row mb-4">
              <div class="vx-col sm: w-1/2 md:w-1/5 mb-4">
                <label>{{ $t("labels.sub_section") }}:</label>
              </div>
              <div class="vx-col sm: w-1/2 mb-4">
                <span>{{ parent_id }}</span>
              </div>
            </div>
            <div class="vx-row mb-4">
              <div class="vx-col sm: w-1/2 md:w-1/5 mb-4">
                <label>{{ $t("labels.number") }}:</label>
              </div>
              <div class="vx-col sm: w-1/2 mb-4">
                <span>{{ number }}</span>
              </div>
            </div>
            <div class="vx-row mb-4">
              <div class="vx-col sm: w-1/2 md:w-1/5 mb-4">
                <label>{{ $t("labels.importance") }}:</label>
              </div>
              <div class="vx-col sm: w-1/2 mb-4">
                <span>{{ importance }}</span>
              </div>
            </div>
            <div class="vx-row mb-4">
              <div class="vx-col sm: w-1/2 md:w-1/5 mb-4">
                <label>{{ $t("labels.owners") }}:</label>
              </div>
              <div class="vx-col sm: w-1/2 mb-4">
                <span>{{ client }}</span>
              </div>
            </div>
            <div class="vx-row mb-4" v-if="this.alltype === 'All'">
              <div class="vx-col sm: w-1/2 md:w-1/5 mb-4">
                <label>{{ $t("labels.vessel_types") }}:</label>
              </div>
              <div class="vx-col sm: w-1/2 mb-4">
                <span>{{ alltype }}</span>
              </div>
            </div>
            <div class="vx-row mb-4" v-if="vessel_type_guidance">
              <div class="vx-col sm: w-1/2 md:w-1/5 mb-4">
                <label>{{ $t("labels.vessel_type_guidance_text") }}:</label>
              </div>
              <div class="vx-col sm: w-1/2 mb-4">
                <span>{{ vessel_type_guidance }}</span>
              </div>
            </div>
            <div class="vx-row mb-4">
              <div class="vx-col sm: w-1/2 md:w-1/5 mb-4">
                <label>{{ $t("labels.services") }}:</label>
              </div>
              <div class="vx-col sm: w-1/2 mb-4">
                <span>{{ services }}</span>
              </div>
            </div>
            <div class="vx-row mb-4" v-if="flag === 'All'">
              <div class="vx-col sm: w-1/2 md:w-1/5 mb-4">
                <label>{{ $t("labels.flags") }}:</label>
              </div>
              <div class="vx-col sm: w-1/2 mb-4">
                <span>{{ flag }}</span>
              </div>
            </div>
            <div class="vx-row mb-4">
              <div class="vx-col sm: w-1/2 md:w-1/5 mb-4">
                <label>{{ $t("labels.designations") }}:</label>
              </div>
              <div class="vx-col sm: w-1/2 mb-4">
                <span>{{ designations }}</span>
              </div>
            </div>

            <div class="vx-row mb-4">
              <div class="vx-col sm: w-1/2 md:w-1/5 mb-4">
                <label>{{ $t("labels.regulation_reference") }}:</label>
              </div>
              <div class="vx-col sm: w-1/2 mb-4">
                <span>{{ regulation_ref }}</span>
              </div>
            </div>
            <div class="vx-row mb-4">
              <div class="vx-col sm: w-1/2 md:w-1/5 mb-4">
                <label>{{ $t("labels.guidance_images") }}:</label>
              </div>
              <div class="vx-col sm: w-1/2 mb-4 flex">
                <span v-for="image in images" class="pr-4" :key="image">
                  <a target="_blank" :href="image">
                    <img :src="image" height="42" width="42" />
                  </a>
                </span>
              </div>
            </div>
            <div class="vx-row mb-4">
              <div class="vx-col sm: w-1/2 md:w-1/5 mb-4">
                <label>{{ $t("labels.active_from") }}:</label>
              </div>
              <div class="vx-col sm: w-1/2 mb-4">
                <span>{{ fromDate | only_date_format }}</span>
              </div>
            </div>
            <div class="vx-row mb-4">
              <div class="vx-col sm: w-1/2 md:w-1/5 mb-4">
                <label>{{ $t("labels.active_to") }}:</label>
              </div>
              <div class="vx-col sm: w-1/2 mb-4">
                <span>{{ toDate | only_date_format }}</span>
              </div>
            </div>
          </div>

        </div>
      </vx-card>
      <div class="vx-row w-full mx-0 mt-6 view-projects">
        <div
          v-for="(specific_vesseltypes,
          index) in specific_vesseltypes_array"
          :key="index"
          :class="[(specific_vesseltypes_array.length % 2 === 1 && specific_vesseltypes_array.length - 1 === index) ? 'md:w-full consultant-view' : 'consultant_details', 'vx-col w-full md:w-1/2 p-0 ']"
        >
          <vx-card
            class="project-details mt-4 mb-6"
            :title="specific_vesseltypes.name+'  ' + $t('labels.guidance')"
          >
            <div class="vx-col sm: w-full mt-4">
              <!-- Work Instruction -->
              <div class="vx-row mb-6">
                <div class="vx-col sm: w-1/2 md:w-1/3 label-center">
                  <label class="font-bold">{{ $t("labels.guidance_text") }}:</label>
                </div>
                <div class="vx-col sm: w-1/2 md:w-2/3 label-center">
                  <span>
                    {{
                    specific_vesseltypes.question_vessel_type.guidance
                    }}
                  </span>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm: w-1/2 md:w-1/3 label-center">
                  <label class="font-bold">{{ $t("labels.subtypes") }}:</label>
                </div>
                <div class="vx-col sm: w-1/2 md:w-2/3 label-center">
                  <span>{{ specific_vesseltypes.vessel_sub_types }}</span>
                </div>
              </div>
            </div>
          </vx-card>
        </div>
      </div>

      <div class="vx-row w-full mx-0 view-projects">
        <div class="md:w-full vx-col w-full md:w-1/2 p-0" v-if="flag !== 'All'">
          <vx-card class="project-details mt-4 mb-6" :title="$t('labels.flag_guidance')">
            <div class="vx-col sm: w-full mt-4">
              <!-- Work Instruction -->
              <div class="vx-row mb-6">
                <div class="vx-col sm: w-1/2 md:w-1/3 label-center">
                  <label class="font-bold">{{ $t("labels.guidance_text") }}:</label>
                </div>
                <div class="vx-col sm: w-1/2 md:w-2/3 label-center">
                  <span>
                    {{
                    flag_guidance
                    }}
                  </span>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm: w-1/2 md:w-1/3 label-center">
                  <label class="font-bold">{{ $t("labels.flags") }}:</label>
                </div>
                <div class="vx-col sm: w-1/2 md:w-2/3 label-center">
                  <span>{{ flag }}</span>
                </div>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      images: [],
      question_number: "",
      question_name: "",
      selected_subtype: "",
      parent_id: "",
      parentSection: [],
      section: "",
      sections: [],
      number: "",
      numbers: [],
      sub_section: 1,
      users: [],
      vesselSubTypes: [],
      subtype_id: "",
      vesselTypes: [],
      parent_type: "",
      vesselParentTypes: [],
      service: [],
      services_drop: [],
      countries: [],
      type: [],
      options: [],
      usertype: "",
      client: "",
      alltype: "",
      importance: "",
      services: "",
      flag: "All",
      flags: [],
      designations: "",
      designation: [],
      designations_drop: [],
      start_date: "",
      end_date: "",
      is_active: "",
      fromDate: "",
      toDate: "",
      configFromdateTimePicker: {
        minDate: new Date(),
        maxDate: ""
      },
      configTodateTimePicker: {
        minDate: ""
      },
      flag_guidance: "",
      regulation_ref: "",
      model: "question",
      id: this.$route.params.id,
      specific_vesseltypes_array: [],
      specific_flag_array: [],
      vessel_type_guidance: ""
    };
  },
  computed: {},
  mounted() {
    this.getQuestions();
  },
  methods: {
    // API Integration for getData
    async getQuestions() {
      this.$vs.loading();
      let response = await this.getHTTPGetResponse(
        "/questions/get/" + this.$route.params.id
      );
      if (response) {
        // let data = response.data;
        let questions = response.data.question;
        this.question_name = questions.question;
        this.section = questions.section.name;
        this.parent_id = questions.sub_section !== null ? questions.sub_section.name : '-';
        this.number = questions.question_number;
        this.importance = questions.importance_name;
        this.is_active = questions.is_active;
        this.flag_guidance = questions.flag_guidance;
        this.vessel_type_guidance = questions.vessel_type_guidance;
        this.regulation_ref = questions.regulation_reference;
        this.fromDate = questions.active_from;
        this.toDate = questions.active_to;
        this.images = questions.images;
        this.specific_vesseltypes_array = questions.vessel_types;
        this.specific_flag_array = questions.flags;
        let cluser = questions.clients;

        if (!questions.all_clients) {
          cluser.forEach(element => {
            this.users.push(element.name);
          });
          this.client = this.users.join(" , ");
        } else this.client = "All";
        if (!questions.all_vessel_types) {
          let types = questions.vessel_types;
          types.forEach(el => {
            var sub_types = el.question_vessel_type.vessel_sub_types;
            let subtype_id = [];
            sub_types.forEach(element => {
              subtype_id.push(element.name);
            });
            el.vessel_sub_types = subtype_id.join(" , ");
          });
        } else this.alltype = "All";

        if (!questions.all_services) {
          let services = questions.services;
          services.forEach(element => {
            this.service.push(element.name);
          });
          this.services = this.service.join(" , ");
        } else this.services = "All";

        if (!questions.all_flags) {
          let flags = questions.flags;
          flags.forEach(element => {
            this.flags.push(element.name);
          });
          this.flag = this.flags.join(" , ");
        } else this.flag = "All";

        if (!questions.all_designations) {
          let designations = questions.designations;
          designations.forEach(element => {
            this.designation.push(element.name);
          });
          this.designations = this.designation.join(" , ");
        } else this.designations = "All";
        this.$vs.loading.close();
      }
    },
    goBack() {
      history.back();
    }
  }
};
</script>
<style scoped>
.view-leads label {
  font-weight: 600;
  margin-right: 10px;
}
h2 {
  font-size: 20px;
  font-weight: 600;
  color: rgba(var(--vs-dark), 1);
}
</style>
